import { createContext, useContext } from 'react';

/**
 * Écriture des éditeurs inline d'un bloc rendu hors du canvas (vue formulaire) :
 * `write(blockId, path, value)` remplace l'envoi à Puck, qui ne connaît que la
 * portée affichée et perdrait sans bruit la frappe d'un bloc d'une autre page.
 * Absent (le canvas), les éditeurs écrivent dans Puck comme avant.
 */
export const BlockPropsWriterContext = createContext(null);

export const useBlockPropsWriter = () => useContext(BlockPropsWriterContext);
